import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';
import it from './locales/it.json';
import el from './locales/el.json';

// Language codes mapping
export const LANGUAGE_CODES = {
  en: 'en',
  de: 'de',
  it: 'it',
  el: 'el', // Greek
} as const;

export type LanguageCode = keyof typeof LANGUAGE_CODES;

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      it: { translation: it },
      el: { translation: el },
    },
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;

